import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ResponsiveLine } from '@nivo/line';
import { AreaLayer } from './Components/AreaLayer';
import { getTrendLineLayer } from './Components/TrendLineLayer';
import { BottomTicksValuesWrapper } from './styles';
import { getFirstYear, getLastYear } from './utils';
import { Text } from '../Text';
export var NivoLineChart = function (_a) {
  var _b, _c, _d, _e, _f, _g, _h, _j;
  var xAxisFormatter = _a.xAxisFormatter,
    _k = _a.xFormat,
    xFormat = _k === void 0 ? 'time:%Y-%m-%d' : _k,
    yAxisFormatter = _a.yAxisFormatter,
    yFormat = _a.yFormat,
    chartLines = _a.chartLines,
    onMouseMove = _a.onMouseMove,
    onMouseLeave = _a.onMouseLeave,
    tooltip = _a.tooltip,
    theme = _a.theme,
    _l = _a.variant,
    variant = _l === void 0 ? 'default' : _l,
    showAreaColor = _a.showAreaColor,
    _m = _a.curve,
    curve = _m === void 0 ? 'linear' : _m,
    _o = _a.lineWidth,
    lineWidth = _o === void 0 ? 2 : _o,
    yScale = _a.yScale,
    xScale = _a.xScale,
    trendValue = _a.trendValue,
    _p = _a.margin,
    margin = _p === void 0 ? {} : _p;
  var localData = chartLines.map(function (chartLine) {
    return {
      id: chartLine.label,
      data: chartLine.data
    };
  });
  var colors = chartLines.map(function (_a) {
    var color = _a.color;
    return color;
  });
  var getXTickValuesPrecision = function (precision) {
    if (precision === 'hour' || precision === 'minute') {
      return 3;
    }
    return 'every year';
  };
  var getLayers = function (showAreaColor, trendValue) {
    if (showAreaColor) {
      return [AreaLayer, 'grid', 'markers', 'axes', 'areas', 'crosshair', 'lines', 'points', 'slices', 'mesh', 'legends'];
    }
    if (trendValue) {
      return ['grid', 'markers', 'axes', getTrendLineLayer(trendValue), 'areas', 'crosshair', 'lines', 'points', 'slices', 'mesh', 'legends'];
    }
    return undefined;
  };
  var variations = variant === 'compact' ? {
    axisLineStrokeFill: theme.tokens.interface.neutral.light,
    axisBottom: {
      format: xAxisFormatter,
      tickPadding: 2,
      tickRotation: 0,
      tickSize: 0,
      tickValues: 0
    },
    axisRight: null,
    enableGridY: false,
    isInteractive: false,
    margin: {
      top: 0,
      right: 0,
      bottom: 1,
      left: 0
    }
  } : {
    axisLineStrokeFill: theme.tokens.interface.neutral.regular,
    axisBottom: {
      format: xAxisFormatter,
      tickPadding: 2,
      tickRotation: 0,
      tickSize: 8,
      tickValues: getXTickValuesPrecision(xScale === null || xScale === void 0 ? void 0 : xScale.precision)
    },
    axisRight: {
      format: yAxisFormatter,
      tickPadding: 16,
      tickRotation: 0,
      tickSize: 8,
      tickValues: 5
    },
    enableGridY: true,
    isInteractive: true,
    margin: {
      top: (_b = margin.top) !== null && _b !== void 0 ? _b : 5,
      right: (_c = margin.right) !== null && _c !== void 0 ? _c : 57,
      bottom: (_d = margin.bottom) !== null && _d !== void 0 ? _d : 30,
      left: (_e = margin.left) !== null && _e !== void 0 ? _e : 22
    }
  };
  return _jsxs(_Fragment, {
    children: [_jsx(ResponsiveLine, {
      data: localData,
      isInteractive: variations.isInteractive,
      curve: curve,
      lineWidth: lineWidth,
      margin: variations.margin,
      xFormat: xFormat,
      yFormat: yFormat,
      xScale: {
        format: (_f = xScale === null || xScale === void 0 ? void 0 : xScale.format) !== null && _f !== void 0 ? _f : '%Y-%m-%d',
        precision: (_g = xScale === null || xScale === void 0 ? void 0 : xScale.precision) !== null && _g !== void 0 ? _g : 'day',
        type: 'time'
      },
      yScale: {
        min: (_h = yScale === null || yScale === void 0 ? void 0 : yScale.min) !== null && _h !== void 0 ? _h : 'auto',
        max: (_j = yScale === null || yScale === void 0 ? void 0 : yScale.max) !== null && _j !== void 0 ? _j : 'auto',
        type: 'linear'
      },
      axisLeft: null,
      axisBottom: variations.axisBottom,
      axisRight: variations.axisRight,
      onMouseMove: function (_a) {
        var _b = _a.data,
          x = _b.x,
          y = _b.y;
        return onMouseMove && onMouseMove({
          x: x,
          y: y
        });
      },
      onMouseLeave: function () {
        return onMouseLeave && onMouseLeave();
      },
      colors: colors,
      enableGridX: false,
      enableGridY: variations.enableGridY,
      enableCrosshair: true,
      crosshairType: "bottom",
      enablePoints: false,
      useMesh: true,
      tooltip: tooltip ? tooltip : undefined,
      layers: getLayers(showAreaColor, trendValue),
      theme: {
        fontSize: 13,
        crosshair: {
          line: {
            stroke: theme.tokens.interface.neutral.strong
          }
        },
        axis: {
          domain: {
            line: {
              stroke: variations.axisLineStrokeFill,
              strokeWidth: 1
            }
          },
          ticks: {
            line: {
              stroke: theme.tokens.interface.neutral.regular
            },
            text: {
              fill: theme.tokens.text.label.regular
            }
          }
        },
        grid: {
          line: {
            stroke: theme.tokens.interface.neutral.light,
            strokeWidth: 1
          }
        }
      }
    }), variant === 'compact' && _jsxs(BottomTicksValuesWrapper, {
      children: [_jsx(Text, {
        el: "span",
        styleName: "bodySmall",
        children: getFirstYear(chartLines)
      }), _jsx(Text, {
        el: "span",
        styleName: "bodySmall",
        children: getLastYear(chartLines)
      })]
    })]
  });
};